import { render, staticRenderFns } from "./Island5.vue?vue&type=template&id=26776fe3"
import script from "./Island5.vue?vue&type=script&lang=js"
export * from "./Island5.vue?vue&type=script&lang=js"
import style0 from "./Island5.vue?vue&type=style&index=0&id=26776fe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports